import { render } from "./CreateAccountModal.vue?vue&type=template&id=bc1c6e48&ts=true"
import script from "./CreateAccountModal.vue?vue&type=script&lang=ts"
export * from "./CreateAccountModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__